/* Floating "Filtruj" pill — ukrywa się gdy przycisk "Pokaż więcej" wchodzi w viewport,
 * wraca gdy scroll wraca powyżej. Bez CSS-only bo scroll direction trudne do wykrycia
 * bez JS. IntersectionObserver = 1 listener, native performance.
 *
 * Prefers-reduced-motion: transition zredukowany do color-only w CSS.
 */
(function () {
	var pill = document.querySelector('.kb-fd-float');
	if (!pill) return;

	// Enter animation — pill startuje schowany pod dolem, .is-mounted transition
	// wjeżdża go do widoku. Delay 150ms = moment "arrival" po pierwszym paincie.
	setTimeout(function () { pill.classList.add('is-mounted'); }, 150);

	var loadMoreBtn = document.querySelector('[data-load-more]');
	if (!loadMoreBtn || !('IntersectionObserver' in window)) return;

	// rootMargin bottom -20px = trigger nieco wcześniej niż button faktycznie się pokaże
	// → smooth handoff między pill a button (nie "flashuje" gdy oba widoczne).
	var io = new IntersectionObserver(function (entries) {
		entries.forEach(function (e) {
			pill.classList.toggle('is-hidden-lm', e.isIntersecting);
		});
	}, { rootMargin: '0px 0px -20px 0px', threshold: 0 });

	io.observe(loadMoreBtn);
})();
